import { Route, RouteConfig } from 'vue-router';
import ArrivalsDeparturesPage from '@/pages/ArrivalsDeparturesPage.vue'
import SignInPage from '@/pages/SignInPage.vue'
import SignInAzureAdPage from '@/pages/SignInAzureAdPage.vue'
import ForgotPasswordPage from '@/pages/ForgotPasswordPage.vue'
import ResetPasswordPage from '@/pages/ResetPasswordPage.vue'
import ContactSupportPage from '@/pages/ContactSupportPage.vue'
import DestinationPage from '@/pages/DestinationPage.vue'
import OrganizationTransportationPermissions from './components/Organization/OrganizationTransportationPermissions.vue';
import TimetablePage from '@/pages/TimetablePage.vue'
import TimetableList from '@/components/Timetable/views/TimetableList.vue'
import TimetableView from '@/components/Timetable/views/TimetableView.vue'
import BookingList from '@/components/Booking/views/BookingList.vue'
import OrganizationPage from '@/pages/OrganizationPage.vue';
import OrganizationDetails from '@/components/Organization/OrganizationDetails.vue';
import {RolePermission} from '@/models/Role'
import PassengerGroupPassenger from './components/Organization/PassengerGroupPassengers.vue';
import UsersPage from './components/Organization/UsersPage.vue';
import DestinationsPage from './components/Organization/DestinationsPage.vue';
import PassengerGroupsPage from './components/Organization/PassengerGroupsPage.vue';
import OrganizationAuthTenantsPage from './components/Organization/OrganizationAuthTenantsPage.vue';
import PassengerPage from './pages/PassengerPage.vue';
import PassengerPageRoot from './pages/PassengerPageRoot.vue';
import PassengerImportsPage from '@/components/Importer/PassengerImportsPage.vue';
import MassCancellationOfTripsView from './pages/MassCancellationOfTripsView.vue';

class Routes {

  // route level code-splitting how-to
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  //    component: () => import(/* webpackChunkName: "about" */ './pages/About.vue'),

  public static rootRoute: RouteConfig = 
  {
    path: '/',
    redirect: "/d/0"
  }

  public static signInRoute: RouteConfig =  {
    path: '/signin',
    name: 'Sign in',
    meta: { 
      allowAnonymous: true,
      hideMenus: true,
      hideRefresh: true
    },
    component: SignInPage,
  };

  public static signInAzureAdRoute: RouteConfig =  {
    path: '/signInAzureAd',
    name: 'Sign in with Microsoft 365',
    meta: { 
      allowAnonymous: true,
      hideMenus: true,
      hideRefresh: true
    },
    component: SignInAzureAdPage
  };

  public static forgotPasswordRoute: RouteConfig =  {
    path: '/forgotPassword',
    name: 'Forgot password',
    meta: { 
      allowAnonymous: true,
      hideMenus: true,
      hideRefresh: true
    },
    component: ForgotPasswordPage
  };

  public static resetPasswordRoute: RouteConfig =  {
    path: '/resetPassword',
    name: 'Reset password',
    meta: { 
      allowAnonymous: true,
      hideMenus: true,
      hideRefresh: true
    },
    component: ResetPasswordPage
  };

  public static contactSupportRoute: RouteConfig =  {
    path: 'contactSupport',
    name: 'Contact support',
    meta: {
      showDestinationSelector: true,
      hideRefresh: true
    },
    component: ContactSupportPage,
  };

  public static aboutRoute: RouteConfig =  {
    path: '/about',
    name: 'About',
    meta: {
      hideRefresh: true,
      showDestinationSelector: true,
    },
    component: () => import(/* webpackChunkName: "about" */ './pages/AboutPage.vue'),
  };

  // Destination child routes
  public static arrivalsDeparturesRoute: RouteConfig = 
  {
    path: 'arrivals-departures',
    component: ArrivalsDeparturesPage,
    name: 'ArrivalsDepartures',
    meta: {
      nav: true,
      i18n: 'route.arrivals-departures',
      showDestinationSelector: true,
      requireDestinationPermissions: [RolePermission.ReadArrivalDepartures]
    },
    children: [
      {
        path: 'day/:dateId',
        component: ArrivalsDeparturesPage,
        name: 'ArrivalsDeparturesDestinationDay',
        meta: {
          showDestinationSelector: true,
        },
      }
    ]
  }


  public static bookingListCreateNewRoute: RouteConfig = {
    path: 'single/:state/create',
    component: BookingList,
    name: 'BookingListCreateNew',
    meta: {
      showDestinationSelector: true,
      requireDestinationPermissions: [RolePermission.ReadBookings, RolePermission.CreateBookings]
    }
  }

  public static bookingListWithStateRoute: RouteConfig = {
    path: 'single/:state',
    component: BookingList,
    name: 'BookingListWithState',
    meta: {
      showDestinationSelector: true,
      requireDestinationPermissions: [RolePermission.ReadBookings]
    }
  }

  public static bookingListRoute: RouteConfig = {
    path: 'single',
    component: BookingList,
    name: 'BookingList',
    // redirect: { name: Routes.bookingListWithStateRoute.name, params: { state: 'new' } },
    meta: {
      showDestinationSelector: true,
      requireDestinationPermissions: [RolePermission.ReadBookings]
    }
  }

  public static timetableListCreateNewRoute: RouteConfig = {
    path: 'recurring/:state/create',
    component: TimetableList,
    name: 'TimetableListCreateNew',
    meta: {
      showDestinationSelector: true,
      requireDestinationPermissions: [RolePermission.ReadTimetables, RolePermission.CreateTimetables]
    }
  }

  public static timetableListWithStateRoute: RouteConfig = {
    path: 'recurring/:state',
    component: TimetableList,
    name: 'TimetableListWithState',
    meta: {
      showDestinationSelector: true,
      requireDestinationPermissions: [RolePermission.ReadTimetables]
    }
  }

  public static timetableListRoute: RouteConfig = {
    path: 'recurring',
    component: TimetableList,
    name: 'TimetableList',
    // redirect: { name: Routes.timetableListWithStateRoute.name, params: { state: 'new' } },
    meta: {
      showDestinationSelector: true,
      requireDestinationPermissions: [RolePermission.ReadTimetables]
    }
  }

  public static timetableRoute: RouteConfig =    {
    path: 'tt/:timetableId',
    component: TimetableView,
    name: 'Timetable',
    meta: {
      showDestinationSelector: true,
      requireDestinationPermissions: [RolePermission.ReadTimetables]
    },
    children: [
      {
        path: 'p/:passengerId',
        name: 'TimetablePassenger',
        children: [
          {
            path: 'w/:weekDayId',
            name: 'TimetablePassengerWeekday',
            children: [
              {
                path: 'r/:rideId',
                name: 'TimetablePassengerWeekdayRide',
              }
            ]
          }
        ]
      }
    ]
  }

  public static singleBooking: RouteConfig = {
    path: 'timetables',
    component: TimetablePage,
    name: 'SingleBooking',
    meta: {
      nav: true,
      i18n: 'route.timetables',
      requireDestinationPermissions: [RolePermission.ReadBookings],
      showDestinationSelector: true,
    },
    redirect: { name: 'BookingListWithState' },
    children: []
  }


  public static timetablesRoute: RouteConfig = {
    path: 'timetables',
    component: TimetablePage,
    name: 'Timetables',
    meta: {
      nav: true,
      i18n: 'route.timetables',
      requireDestinationPermissions: [RolePermission.ReadTimetables],
      showDestinationSelector: true,
    },
    redirect: { name: 'TimetableList' },
    children: [
      Routes.timetableListRoute,
      Routes.timetableListWithStateRoute,
      Routes.timetableListCreateNewRoute,
      Routes.bookingListRoute,
      Routes.bookingListWithStateRoute,
      Routes.bookingListCreateNewRoute,
      Routes.timetableRoute,
    ]
  }

  public static newPassengerRoute: RouteConfig = {
    path: 'newPassenger',
    component: PassengerPage,
    name: 'NewPassenger',
    meta: {
      i18n: 'route.passenger.new',
      showDestinationSelector: true,
      requireDestinationPermissions: [RolePermission.CreatePassengers],
    }
  }
  
  public static editPassengerRoute: RouteConfig = {
    path: 'edit',
    // component: () => import(/* webpackChunkName: "people" */ './pages/PassengerPage.vue'),
    component: PassengerPage,
    name: 'EditPassenger',
    meta: {
      i18n: 'route.passenger.edit',
      passengerNav: true,
      showDestinationSelector: true,
      requirePassengerPermissions: [RolePermission.ReadPassengers]
    }
  }

  public static passengerRoute: RouteConfig = {
    path: '/passenger/:passengerId',
    component: PassengerPageRoot,
    name: 'Passenger',
    meta: {
      showDestinationSelector: true,
      requirePassengerPermissions: [ RolePermission.ReadPassengers ],
      passengerRoot: true,
    },
    children: [
      Routes.editPassengerRoute,
    ],
  }
  
  public static editPeopleRoute: RouteConfig = {
    path: 'edit/:passengerId',
    // component: () => import(/* webpackChunkName: "people" */ './pages/PassengerPage.vue'),
    component: PassengerPage,
    name: 'EditPeoplePassenger',
    meta: {
      i18n: 'route.passenger.edit',
      passengerNav: true,
      showDestinationSelector: true,
      requirePassengerPermissions: [RolePermission.ReadPassengers]
    }
  }
  
  public static massCancellationOfTrips: RouteConfig = {
    path: 'massCancellationOfTrips',
    // component: () => import(/* webpackChunkName: "people" */ './pages/PassengerPage.vue'),
    component: MassCancellationOfTripsView,
    name: 'massCancellationOfTrips',
    meta: {
      i18n: 'route.tripsMassCancellation',
      nav: true,
      showDestinationSelector: true,
      requireDestinationPermissions: [RolePermission.CreateTimetables]
    }
  }

  public static peopleRoute: RouteConfig = {
    path: 'people',
    component: () => import(/* webpackChunkName: "people" */ './pages/PeoplePage.vue'),
    name: 'People',
    meta: {
      nav: true,
      i18n: 'route.people',
      showDestinationSelector: true,
      requireDestinationPermissions: [RolePermission.ReadPassengers, RolePermission.UpdatePassengerGroups]
    },
    children: [
      Routes.newPassengerRoute,
      Routes.editPeopleRoute,
    ]
  }

  public static destinationRoute: RouteConfig = 
  {
    path: '/d/:destinationId',
    name: "Destination",
    component: DestinationPage,
    meta: {
      showDestinationSelector: true,
    },
    children: [
      Routes.peopleRoute,
      Routes.arrivalsDeparturesRoute,
      Routes.timetablesRoute,
      Routes.singleBooking,
      Routes.massCancellationOfTrips,
      Routes.contactSupportRoute
    ]
  }

  public static organizationDetails: RouteConfig = {
    path: 'details',
    component: OrganizationDetails,
    name: 'OrganizationDetails', 
    meta: {
      showDestinationSelector: true,
    },
  }

  public static organizationNewUserRoute: RouteConfig = {
    path: 'user/new',
    component: () => import(/* webpackChunkName: "organization" */ './components/Organization/UserEditor.vue'), 
    name: 'NewUser',
    meta: {
      showDestinationSelector: true,
    },
  }

  public static newOrganizationPassenger: RouteConfig = {
    path: 'passenger/new',
    component: PassengerPage,
    name: 'NewOrganizationPassenger',
    meta: {
      showDestinationSelector: true,
      requirePassengerPermissions: [RolePermission.CreatePassengers],
    },
  }
  
  public static organizationEditUserRoute: RouteConfig = {
    path: 'user/edit/:userEmail',
    component: () => import(/* webpackChunkName: "organization" */ './components/Organization/UserEditor.vue'), 
    name: 'EditUser',
    meta: {
      showDestinationSelector: true,
    },
  }
  
  public static passengerGroup: RouteConfig = {
    path: 'passengerGroup/:passengerGroupId',
    component: PassengerGroupPassenger,
    name: 'PassengerGroupView',
    meta: {
      showDestinationSelector: true,
    },
    children: [
      Routes.newOrganizationPassenger,
    ],
  }

  public static organizationPassengerGroups: RouteConfig = {
    path: 'passengerGroup',
    component: PassengerGroupsPage,
    name: 'OrganizationPassengerGroups', 
    meta: {
      organizationNav: true,
      requireAdmin: false,
      i18n: 'route.organization_passenger_groups',
      showDestinationSelector: true,
    },
  }

  public static organizationUsers: RouteConfig = {
    path: 'users',
    component: UsersPage,
    name: 'OrganizationUsers',
    meta: {
      organizationNav: true,
      requireAdmin: true,
      i18n: 'route.organization_users',
      showDestinationSelector: true,
    },
  }
  public static organizationDestinations: RouteConfig = {
    path: 'destinations',
    component: DestinationsPage,
    name: 'OrganizationDestinations',
    meta: {
      organizationNav: true,
      requireAdmin: true,
      i18n: 'route.organization_destinations',
      showDestinationSelector: true,
    },
  }

  public static organizationPassengerImports: RouteConfig = {
    path: 'import',
    component: PassengerImportsPage,
    name: 'PassengerImports',
    meta: {
      organizationNav: true,
      requireAdmin: true,
      i18n: 'route.organization_passenger_imports',
      showDestinationSelector: true,
    }
  }

  public static organizationPassengerTransportationPermissions: RouteConfig = {
    path: 'transportationPermissions',
    component: OrganizationTransportationPermissions,
    name: 'OrganizationPassengerTransportationPermissions',
    meta: {
      organizationNav: true,
      requireAdmin: true,
      i18n: 'route.organization_passenger_transportation_permissions',
      showDestinationSelector: true,
    },
  }
  public static organizationAuthTenants: RouteConfig = {
    path: 'authTenants',
    component: OrganizationAuthTenantsPage,
    name: 'OrganizationAuthTenants',
    meta: {
      organizationNav: true,
      requireAdmin: true,
      i18n: 'route.organization_auth_tenants',
      showDestinationSelector: true,
    },
  }

  public static organizationRoute: RouteConfig = {
    path: '/o/:organizationId',
    name: "Organization",
    component: OrganizationPage,
    children: [
      Routes.organizationDetails,
      Routes.organizationNewUserRoute,
      Routes.organizationEditUserRoute,
      Routes.passengerGroup,
      Routes.organizationPassengerGroups,
      Routes.organizationUsers,
      Routes.organizationDestinations,
      Routes.organizationPassengerTransportationPermissions,
      Routes.organizationPassengerImports,
      // Routes.organizationAuthTenants,
    ],
    meta: {
      organizationRoot: true,
      showDestinationSelector: true,
      // i18n: 'route.organizations',
      // // TODO: Set up a new rolepermssion for organizations
      // requirePermissions: [RolePermission.ReadAllPassengerTrips]
    }
  }

  public static routes: RouteConfig[] = [
    Routes.rootRoute,
    Routes.destinationRoute,
    // Routes.passengerDetails,
    Routes.signInRoute,
    Routes.signInAzureAdRoute,
    Routes.forgotPasswordRoute,
    Routes.resetPasswordRoute,
    Routes.aboutRoute,
    Routes.organizationRoute,
    Routes.passengerRoute,
  ];
}

export default Routes;
